import React from 'react';
import Sidebar from './Sidebar';

interface SidebarWrapperProps {
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

const SidebarWrapper: React.FC<SidebarWrapperProps> = ({ isCollapsed, setIsCollapsed }) => {
  return (
    <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
  );
};

export default SidebarWrapper;